import { useNavigate } from "react-router-dom"
import MTable from "../../../../components/mtable"
import CollapsingSection from "../../../../components/CollapsingSection"

export default function CompanyTracks({ companyId }) {

    const navigate = useNavigate()

    const mapper = { columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Display Name",
            value: (item) => item.displayName
        },
        {
            label: "Status",
            value: (item) => item.status
        }
    ]}

    return (
        <CollapsingSection
            title="Tracks"
            actionButtons={<button className="text" onClick={() => navigate('manage-tracks')}>Manage Access</button>}
        >
            <MTable path={'tracks'} queryParams={{ companyId }} mapper={mapper} />
        </CollapsingSection>
    )
}
